import React from 'react';
import Skeleton from 'src/Admin/components/common/skeleton';

const Lists = ({ data, selectChangeHandler, searchString }) => {
  const onChangeHandler = (e) => {
    selectChangeHandler(e);
  };

  const IconFacility = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8125 4.54688H8.5625V2.29688H7.4375V4.54688H5.1875V5.67188H7.4375V7.92188H8.5625V5.67188H10.8125V4.54688Z"
        fill="#884EA2"
      />
      <path
        d="M14.75 4.54688H13.625V1.17188C13.6247 0.873598 13.5061 0.587623 13.2952 0.376709C13.0843 0.165795 12.7983 0.0471728 12.5 0.046875H3.5C3.20172 0.0471728 2.91575 0.165795 2.70483 0.376709C2.49392 0.587623 2.3753 0.873598 2.375 1.17188V4.54688H1.25C0.951723 4.54717 0.665748 4.66579 0.454834 4.87671C0.24392 5.08762 0.125298 5.3736 0.125 5.67188V15.7969H15.875V5.67188C15.8747 5.3736 15.7561 5.08762 15.5452 4.87671C15.3343 4.66579 15.0483 4.54717 14.75 4.54688ZM6.875 14.6719V11.2969H9.125V14.6719H6.875ZM10.25 14.6719V10.7344C10.25 10.5852 10.1907 10.4421 10.0852 10.3366C9.97976 10.2311 9.83668 10.1719 9.6875 10.1719H6.3125C6.16332 10.1719 6.02024 10.2311 5.91475 10.3366C5.80926 10.4421 5.75 10.5852 5.75 10.7344V14.6719H1.25V5.67188H3.5V1.17188H12.5V5.67188H14.75V14.6719H10.25Z"
        fill="#884EA2"
      />
    </svg>
  );

  return (
    <div className="blob-lists blob-lists-height">
      {data ? (
        data.map((item, index) => {
          return (
            <div key={index}>
              <div className="blob-list-item-border">
                <div className="d-flex broker-list-item">
                  <div className="d-flex">
                    <div className="d-flex mb-2">
                      <input
                        type="checkbox"
                        id={item.FacilityOID}
                        name={item.FacilityOID}
                        className="p-0 mt-auto mb-auto"
                        onChange={(e) => onChangeHandler(e)}
                        checked={item?.isChecked || false}
                      />
                    </div>
                    <div className="facility-icon-div">
                      <div className="facility-icon">
                        <IconFacility />
                      </div>
                    </div>
                    <div>
                      <div>
                        <span className="blob-item-name-1">
                          {item.FacilityName}
                        </span>
                      </div>
                      <div className="blob-item-desc-1">
                        {item.Address[0].address1 +
                          ',' +
                          item.Address[0].city +
                          ',' +
                          item.Address[0].state_prov +
                          ',' +
                          item.Address[0].postalCode}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="blob-item-desc-2">&nbsp;</div>
                    {item.TaxId && (
                      <div className="blob-item-desc-3">
                        Tax ID: {item.TaxId}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <Skeleton count={20} height={30} />
      )}
    </div>
  );
};

export default Lists;
